module.exports = __webpack_public_path__ + "img/luoyang.ad289b0d.jpg";